module.exports = __webpack_public_path__ + "assets/img/elem3-ability1.82e946ed.gif";